/** Human-readable durations, shared by the analytics dashboards. */
export function formatDuration(ms: number | null | undefined, fallback: string): string {
  if (ms === null || ms === undefined) return fallback
  // An agent answers in seconds; rounding those to «0 min» reads as no work at all.
  if (ms < 1_000) return "<1 sec"
  if (ms < 59_500) return `${Math.round(ms / 1_000)} sec`

  const hours = ms / 3_600_000
  if (hours < 1) return `${Math.round(ms / 60_000)} min`
  if (hours < 48) return `${hours.toFixed(1)} hrs`
  return `${(hours / 24).toFixed(1)} days`
}

/** A 0–1 share as a whole percentage, or `empty` when there is no population to share. */
export function formatShare(value: number | null, empty: string): string {
  return value === null ? empty : `${wholePercent(value)}%`
}

/** The rounding every displayed share uses, so a change agrees with the shares it compares. */
export function wholePercent(share: number): number {
  return Math.round(share * 100)
}
